import "@repo/design-system/styles";
import "@repo/reusable-components/styles";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactDOM from "react-dom/client";
// import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
// import 'react-calendar/dist/Calendar.css';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import Idle from "react-idle";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import reducer from "./redux/reducer";

const root = ReactDOM.createRoot(document.getElementById("root"));

const rootReducer = combineReducers({ globalState: reducer });

const store = configureStore({ reducer: rootReducer });

root.render(
  <Idle
    timeout={30 * 60 * 1000}
    render={
      ({ idle }) => (
        // <React.StrictMode>
        <Provider store={store}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <BrowserRouter>
              <App idle={idle} />
            </BrowserRouter>
          </LocalizationProvider>
        </Provider>
      )
      // </React.StrictMode>
    }
  />,
);
